exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-390c6284]{background-color:#f2f6fc;border:1px dashed #999;border-radius:5px;position:relative}.image .initB[data-v-390c6284],.image img[data-v-390c6284]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image img[data-v-390c6284]{display:block;width:100%}.image .initB[data-v-390c6284]{width:30%}.image.enable[data-v-390c6284]:after{position:absolute;width:100%;height:100%;content:\"\";background-color:#c0c4cc;opacity:.4;cursor:not-allowed;left:0;top:0;z-index:11}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-390c6284","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/YaSub/src/YaSub.vue
// module id = 43
// module chunks = 0